import reactStringReplace from 'react-string-replace';
import { randomId } from '../../utils';

function isAlphanumeric(string: string) {
    return string.match(/^[A-Za-z0-9]+$/);
}

export function emphasiseSearchTerm(text: string, searchTerm: string): string | React.ReactNode[] {
    if (!searchTerm) {
        return text;
    }
    const termParts = searchTerm
        .trim()
        .split(' ')
        .filter((part) => Boolean(part));

    let processedText: string | React.ReactNode[] = text;

    termParts.forEach((word) => {
        // Form a regular expression from the alpha numeric characters of the word
        const chars = word.split('').filter((char) => isAlphanumeric(char));

        let regString = '';
        chars.forEach((char, index) => {
            regString += char;
            if (index < chars.length - 1) {
                regString += '\\s*';
            }
        });

        regString = `(${regString})`; // reactStringReplace requires a matching group
        const regex = new RegExp(regString, 'iu'); // Create a case insensitive expression

        // perform a match and replace
        processedText = reactStringReplace(processedText, regex, (match: string) => (
            <span key={randomId()} data-emphasise={true}>
                {match}
            </span>
        ));
    });

    return processedText;
}
